<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="核算周期：">
                <el-date-picker v-model="searchForm.countBatch" type="month" placeholder="选择结算月份" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="未结算"></el-option>
                    <el-option value="1" label="已结算"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="代理商名称：">
                <el-input v-model="searchForm.agentName" @keyup.enter.native="getOrderSettlementListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getOrderSettlementListHandler">搜索查询</el-button>
                <el-button type="success" @click="confirmExportDialogVisible = true">导出Excel</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="agentName" label="代理商名称"></el-table-column>
            <el-table-column prop="countBatch" label="核算周期"></el-table-column>
            <el-table-column prop="createTime" label="核算时间"></el-table-column>
            <el-table-column prop="orderTotalNum" label="订单总数"></el-table-column>
            <el-table-column prop="orderTotalPriceRmb" label="订单总额" width="120"></el-table-column>            
            <el-table-column prop="orderCommissionPriceRmb" label="总佣金" width="120"></el-table-column>
            <!-- <el-table-column prop="backCommissionPriceRmb" label="秒返金额（元）"  width="120"></el-table-column> -->
            <el-table-column prop="returnCommissionPriceRmb" label="退款金额（元）" width="120"></el-table-column>
            <el-table-column prop="extractablePriceRmb" label="返现金额" width="120"></el-table-column>
             <el-table-column label="税后应收金额（6%税）" width="160">
                <template v-slot="scope" >
                    <span>{{numFilter(scope.row.extractablePriceRmb * 0.94)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="authName" label="实名认证状态"></el-table-column>
            <el-table-column prop="stateName" label="状态"></el-table-column>
            <el-table-column prop="countTime" label="结算时间"></el-table-column> 
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.state == 0" type="text" @click="settlementHandler(scope.row.id)">核算</el-button>
                </template>                
            </el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrderFinancialHandle">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getOrderSettlementList, orderSettlement, exportFinancialInfo} from '@/api/finance.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                countBatch: '',
                state: '',
                agentName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            confirmExportDialogVisible:false//导出确认框
        }
    },
    methods: {
        // 截取当前数据到小数点后两位
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
        getOrderSettlementListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getOrderSettlementList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        settlementHandler(id){
            var data = {id}
            orderSettlement(data).then(res => {
                if(res.data.code == 200){                    
                    this.$message.success(res.data.message)
                    this.getOrderSettlementListHandler();
                }else{
                    this.$message.error(res.data.message)
                }
            })            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getOrderSettlementListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getOrderSettlementListHandler();
        },
        exportOrderFinancialHandle(){
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            exportFinancialInfo(data).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去下载专区下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));     
        }         
    },
    created () {
        this.getOrderSettlementListHandler();
    }
}
</script>
<style>

</style>